/**
 * Copyright 2025 Paion Data. All rights reserved.
 */
import "./BackButton.css";
import { Link } from "react-router-dom";

export default function BackButton(): JSX.Element {
  return (
    <Link to="/">
      <button className="button-24" role="button">
        Home
      </button>
    </Link>
  );
}
